// Файл resize_observer_error_filter.js

/**
 * Модуль обслуживает сценарий `resize_observer_error_filter` в разделе
 * `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

const resize_observer_error_messages = new Set([
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
]);

const resize_observer_filter_key = (
    '__nimbus_resize_observer_error_filter__'
);

const is_resize_observer_error = (event) => {
    const error_message = String(
        event?.message
        || event?.error?.message
        || ''
    ).trim();

    return resize_observer_error_messages.has(error_message);
};

const handle_resize_observer_error = (event) => {
    if (!is_resize_observer_error(event)) {
        return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
};

const install_resize_observer_error_filter = () => {
    if (window[resize_observer_filter_key]) {
        return;
    }

    window.addEventListener(
        'error',
        handle_resize_observer_error,
        true,
    );
    window[resize_observer_filter_key] = true;
};


export {
    install_resize_observer_error_filter,
};
